import React, { useEffect, useState } from 'react'
import { CardNumberElement, CardExpiryElement, CardCvcElement, AddressElement } from '@stripe/react-stripe-js'
import StripeInputEl from './StripeInputEl'
import pubsub from "@viewlift/pubsub"
import { getDiscountPrice, validateSubscriptionOfferCodeByPlanId } from './Api'
import InputEl from "./InputEl"
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { addPaymentInfo, fetchUserObject } from './helper'
import { ANALYTICSEVENTS } from '../../LoginV2/Helpers/analyticsMap'
import StripeButtons from './StripeButtons'
import { publishTveStatus, subscribeTveStatus } from '../../Events/tve.events'
import { publishProcessStripePayment, subscribeApplyOfferCode, subscribeMonetisationcontinue, subscribeRemoveOfferCode } from '../../Events/monetisation.events'
import { parseJSON } from '../../utils/parseJSON'
import { enableCardFormEvent, publishAppLoading, publishErrorUpdate, publishNotificationUpdate } from '../../Events/utils.events'
import StripeAddressForm from './AddressForm'
import localforage from 'localforage'
import { publishIsActive } from '../../Events/plans.events'
import { fetchCurrentPlan, structuredPlan } from '../../PlansWrapper/helper'
import { pushStepToFlow } from '../../helper'
import trackEvent from '../../../helpers/trackAnalytics'
import { handleStatusGaCalls } from '../../../helpers'
import logger from '../../../logger';
const CcForm = ({ metadataMap, moduleData, checkoutModuleData, isUpgrade }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [validating, setValidating] = useState(false)
    const [offerCodeError, setOfferCodeError] = useState(false)
    const [offerCodeSuccess, setOfferCodeSuccess] = useState(false)
    const [offerCodeDetails, setOfferCodeDetails] = useState({})
    const [offer, setOfferCode] = useState(null)
    const [isValid, setIsValid] = useState(false)
    const [isTvod, setIsTvod] = useState(false)
    const [isDisabled, setIsDisabled] = useState(true)
    const [billingValue, setBillingValue] = useState(false)
    let billingAgreementText = metadataMap?.billingAgreement;
    let enableAddressForm = window?.app_data?.appcmsMain?.paymentProviders?.stripe?.showPaymentAddress || false
    let checkoutMetadataMap = checkoutModuleData?.moduleData?.metadataMap
    const handleStripeElement = () => {
        const cardElement = elements.getElement(CardNumberElement);
        const addressElement = elements.getElement(AddressElement)
        publishProcessStripePayment({ value: true, formRef: { elements, stripe, cardElement, addressElement } })
    }
    const handleFormRefPublish = (data) => {
       data && handleStripeElement()
    }
    const getisValid = (data) => {
        setIsValid(data)
    }
    const escapeHtml = (text) => {
        const htmlEntities = {
            '"': "&quot;",
            "&": "&amp;",
            "'": "&#039;",
            "<": "&lt;",
            ">": "&gt;"
        };
        return text.replace(/["&'<>]/g, (char) => htmlEntities[char] || char);
      };
      const sanitizedTosText = metadataMap?.termsOfServiceText ? escapeHtml(metadataMap?.termsOfServiceText) : '';
      const sanitizedPrivacyPolicyText = metadataMap?.privacyPolicyText ? escapeHtml(metadataMap?.privacyPolicyText) : '';

    const handleTveSelected = (data) => {
        setIsDisabled(data)
    }
    const handleEnableCardForm = (data) => {
        setIsDisabled(data)
    }
    const disabledColour = "rgb(183 186 194)"

    const handleApplyCode = (data) => {
        localforage.getItem('CheckoutStore').then((store) => {
            let allPlans = store?.plansDetail?.allPlans || []
            let offerPlan = allPlans?.filter((plan) => plan?.id === data?.planId)
            if (!offerPlan?.length) {
                publishErrorUpdate("Offer code is not applicable")
                return
            }
            data.offerPlan = offerPlan[0]
            onClickApply(null,data)
        })
    }
    const checkForParamsOffer = () => {
        // applies offer if present in query params
        const params = new URLSearchParams(window.location.search)
        const paramOffer = params.get('offer')
        if (paramOffer && !isUpgrade) onClickApply()
    }

    useEffect(() => {
        fetchUserObject().then((response) => {
            if(response?.email || response?.phoneNumber){
                setIsDisabled(false)
            }
          })
    },[])

    useEffect(() => {
        publishTveStatus(false) //re-initializing stripe form
        subscribeTveStatus(handleTveSelected)
        subscribeMonetisationcontinue(handleFormRefPublish)
        subscribeRemoveOfferCode(removeCode)
        subscribeApplyOfferCode(handleApplyCode)
        enableCardFormEvent(handleEnableCardForm)
        pubsub.subscribe("stripeComplete", getisValid)
        checkForParamsOffer()
        publishAppLoading(false)
    }, [])

    const handleBillingChange = () => {
        setBillingValue(!billingValue)
    }

    const appendText = () => {
        billingAgreementText = metadataMap.billingAgreement?.replace('$terms_of_service$', `<a aria-label=${sanitizedTosText} href="${encodeURI(metadataMap?.termsPermalink)}" class="consentLinks" target="_blank">${sanitizedTosText}</a>`);
        billingAgreementText = billingAgreementText?.replace('$privacy_policy$', `<a aria-label=${sanitizedPrivacyPolicyText} href="${encodeURI(metadataMap?.privacyPermalink)}" class="consentLinks" target="_blank">${sanitizedPrivacyPolicyText}</a>`);
        let billingAgreementData = document.getElementById('billingAgreementData');
        if(billingAgreementData){
            billingAgreementData.innerText = '';
            billingAgreementData.insertAdjacentHTML('beforeend', billingAgreementText);
        }
    };

    const onClickApply = async (e,data) => {
        e?.stopPropagation()
        e?.preventDefault()
        let currentPlan = fetchCurrentPlan()
        if (data) {
            if (currentPlan?.planId !== data?.offerPlan?.id) {
                let plan = structuredPlan(data?.offerPlan,currentPlan?.subscriptionPopupFonts)
                let planDetails = {
                    id: plan?.planId,
                    features: plan?.features
                  }
                  sessionStorage.setItem('currentPlan',JSON.stringify(plan))
                  currentPlan = plan
                  publishIsActive({ planDetails, selectedPlanId: plan?.planId, plan })
            }
        }
        setValidating(true)
        const params = new URLSearchParams(window.location.search)
        const paramOffer = params.get('offer')
        let offerCode = paramOffer || (e?.target && e?.target?.value?.toUpperCase()) || offer?.toUpperCase() || data?.promocode
        sessionStorage.setItem('offerCode', offerCode)
        let planId = currentPlan.planId || currentPlan?.id
        if (!offerCodeDetails) {
            setValidating(false)
            pubsub.publish('isLoading', false)
            return false
        }
        const offerValidatePayload = {
            offerCode: offerCode,
            subscriptionPlanId: planId,
            site: window?.app_data?.site?.siteInternalName,
        }
        handleStatusGaCalls({eventName : 'apply_code_status', type : 'apply-code', reason : offerCode, status : 'initiate', action : 'Apply Promo Code', paymentStatus : null,eventCategory : 'Payment',section : 'checkout'})
        let validateOfferResponse = await validateSubscriptionOfferCodeByPlanId(offerValidatePayload)
        if (!validateOfferResponse.isError) {
            let offerCodeAnalyticsData = {
                "promotionCode": validateOfferResponse?.data?.id,
                "offerName": validateOfferResponse?.data?.name,
                "offerType": validateOfferResponse?.data?.offerDetails?.offerStrategyType,
                "offerAdd": 'Manual'
            }
            setValidating(false)
            let offerCodeMessage = checkoutMetadataMap?.offerCodeAppliedText?.replace("$VIEWLIFT_OFFERCODER", offerCode)
            publishNotificationUpdate({message : offerCodeMessage || 'Promo Code Applied', type : "OFFER"})
            setOfferCodeDetails({
                displayName: validateOfferResponse.data.displayName,
                name: validateOfferResponse.data.name,
                code: offerCode
            })
            setOfferCode(`${validateOfferResponse.data.displayName || validateOfferResponse.data.name}`)
            getActualPrice(offerCodeAnalyticsData)
            addPaymentInfo(currentPlan,{
                displayName: validateOfferResponse.data.displayName,
                name: validateOfferResponse.data.name,
                code: offerCode
            })
            setTimeout(() => setOfferCodeSuccess(false), 5000)

            handleStatusGaCalls({eventName : 'apply_code_status', type : 'apply-code', reason : offerCode, status : 'success', action : 'Apply Promo Code', paymentStatus : null,eventCategory : 'Payment',section : 'checkout'})
            handleStatusGaCalls({eventName : 'select_promotion', type : 'apply-code', reason : offerCode, status : 'success', action : 'Apply Promo Code', paymentStatus : null,eventCategory : 'Payment',section : 'checkout'})
        }
        if (validateOfferResponse.isError) {
            setValidating(false)   
            pubsub.publish('isLoading', false)
            sessionStorage.removeItem('offerCode', offerCode)
            logger(validateOfferResponse)
            publishErrorUpdate(metadataMap?.promoValidatingError || 'Invalid Promo Code')
            handleStatusGaCalls({eventName : 'apply_code_status', type : 'apply-code', reason : offerCode, status : 'failure', action : 'Apply Promo Code', paymentStatus : null,eventCategory : 'Payment',section : 'checkout'})
            handleStatusGaCalls({eventName : 'select_promotion', type : 'apply-code', reason : offerCode, status : 'failure', action : 'Apply Promo Code', paymentStatus : null,eventCategory : 'Payment',section : 'checkout'})
        }
    }
    const removeCode = () => {
        let offerCode = sessionStorage.getItem('offerCode')
        if (!offerCode) {
            setOfferCodeDetails({})
            setOfferCode("")
            return
        }
        sessionStorage.removeItem('offerCode')
        setOfferCodeDetails({})
        setOfferCode("")
        getActualPrice()
    }
    const getActualPrice = async (offerCodeAnalyticsData) => {
        let offerCode = sessionStorage.getItem('offerCode') || null
        let currentPlan = parseJSON(sessionStorage.getItem('currentPlan'))
        const data = {
            id: currentPlan.id || currentPlan?.planId,
            offerCode: offerCode
        }
        try {
            // handle update plans price using apply-discounted-price
            let res = await getDiscountPrice(data)
            if (offerCode) {
                let userData = await fetchUserObject()
                let offer_code_applied_Payload = {
                  event_label1 : res?.appliedOfferCode,
                  event_label2 : res?.amount,
                  event_label3 : 'pending',
                  logged_in_status : userData?.userId ? 'Yes'  : 'No',
                  subscribed_status : userData?.isSubscribed,
                  email : userData?.email,
                //   mobile : userData?.mobile, // Yes, collecting and sending mobile numbers to Google Analytics 4 (GA4) violates both GDPR and Google's Terms of Service,
                //   last_transaction_amount : null,
                  subscription_plan : currentPlan?.title,
                //user_location : null, //This violates GDPR/Google terms
                  event_category : 'Payment',
                  event_action : 'Apply Offer Code',
                  event_value : res?.amount,
                  payment_status : null
                }
                trackEvent('offer_code_applied',offer_code_applied_Payload,null)
                pushStepToFlow("offer-code-applied")
                offerCodeAnalyticsData.discountAmount = res?.amount
                pubsub.publish('user-analytics',{ename:ANALYTICSEVENTS.OFFER_CODE_APPLIED, data: {...offerCodeAnalyticsData, "discountAmount": res?.amount,}});
            }
        }
        catch (err) {
            // enable error wall
            let offerStatus = err.response && err.response.data && err.response.data.code
            if (offerStatus === "OFFER_ALREADY_USED") {
                sessionStorage.removeItem("offerCode")
            }
        }
    }

    useEffect(()=>{
        appendText()
    },[moduleData])

    const disableCtaColor = moduleData?.layout?.settings?.disabledCTAColor
    const consentColor = moduleData?.layout?.settings?.consentColor
    return (
        <div className='ccform-wrapper'>
            {enableAddressForm ? <StripeAddressForm moduleData={moduleData} isDisabled={isDisabled} /> : <></>}
            <div className='element-wrapper' style={isDisabled ? { pointerEvents: "none" } : {}}>
                <div className='element-heading'>{metadataMap?.cardNumberLabel || 'Card Number'}</div>
                <StripeInputEl
                    El={CardNumberElement}
                    moduleData={moduleData}
                    title={metadataMap?.cardNumberText || 'Card Number'}
                    isDisabled={isDisabled}
                />
            </div>
            <div className="inline-wrapper">
                <div className='element-wrapper' style={isDisabled ? { pointerEvents: "none" } : {}}>
                    <div className='element-heading'>{metadataMap?.expirationLabel || 'Expiry'}</div>
                    <StripeInputEl
                        El={CardExpiryElement}
                        moduleData={moduleData}
                        title={metadataMap?.expiryText || 'Expiry'}
                        isDisabled={isDisabled}
                    />
                </div>
                <div className='element-wrapper' style={isDisabled ? { pointerEvents: "none" } : {}}>
                    <div className='element-heading'>{metadataMap?.verificationLabel || 'CVV'}</div>
                    <StripeInputEl
                        El={CardCvcElement}
                        moduleData={moduleData}
                        isCvc={true}
                        title={metadataMap?.cvcText || 'CVV'}
                        isDisabled={isDisabled}
                    />
                </div>
            </div>
            {!enableAddressForm ?
                <div className='element-wrapper' style={isDisabled ? { pointerEvents: "none" } : {}}>
                    <div className='element-heading'>{metadataMap?.nameLabel || 'Name' }</div>
                    <InputEl
                        title={metadataMap?.nameText || 'Name'}
                        moduleData={moduleData}
                        name="customer_name"
                        isDisabled={isDisabled} /></div> : <></>}
            <div className={isTvod ? "full-w form-2" : 'form-2'}>

                <div className='element-wrapper' style={isDisabled ? { pointerEvents: "none" } : {}}>
                    <div className='element-heading'>{metadataMap?.offerCodeLabel || 'Offer Code'}</div>
                    {/* {currentPlan && !isTvod ?  */}
                    <div className='offer-container'>
                        <div className='coupon-input'>
                            <input
                                aria-labelledby={metadataMap?.addPromoPlaceholder || 'Add Promo'}
                                className={`offer-code-input ${Object.keys(offerCodeDetails).length > 0 ? "applied-code" : ""}`}
                                placeholder={metadataMap?.addPromoPlaceholder || 'Add Promo'}
                                onChange={(e) => {
                                    setOfferCode(e.target.value)
                                    let applyCodeBtn = document.querySelector(".apply")
                                    if (e.target.value) {
                                        applyCodeBtn.style.background = moduleData?.layout?.settings?.activeCTAColor
                                    }
                                    else applyCodeBtn.style.background = "rgba(255, 255, 255, 0.3)"
                                }
                                }
                                onKeyPress={e => { if (e.key === 'Enter' && offer) onClickApply(e) }}
                                value={offer}
                                style={isDisabled ? { background: disabledColour } : { background: moduleData?.layout?.settings?.inputColor || "transparent", color :"#000" }}
                            />
                            {Object.keys(offerCodeDetails).length > 0 &&
                                <button
                                    aria-label="cancel"
                                    className="remove-code-btn  site-cta-color site-cta-background-color "
                                    onClick={() => {
                                        removeCode(false)
                                    }}>
                                    {metadataMap?.cancelPromo || 'cancel'}
                                </button>
                            }
                            {!offerCodeSuccess && Object.keys(offerCodeDetails).length == 0 && <button
                                disabled={!offer}
                                style={!offer ? { background: disableCtaColor } : {}}
                                aria-label="apply"
                                className={`apply site-cta-color ${validating ? ' processing' : ''}`}
                                onClick={(e) => onClickApply(e)}>
                                {validating ? metadataMap?.processingTxt || 'Processing' : metadataMap?.applyCode || 'Apply'}
                            </button>}
                        </div>
                    </div>
                </div>
                {/* : <></>} */}
            </div>
            <div tabIndex={0} className="custom-checkbox-wrapper">
                <div tabIndex={0} className="container" onClick={handleBillingChange}>
                    <input aria-labelledby='Consent Checkbox' tabIndex={0} id="consent" type="checkbox" name="consent" checked={billingValue} />
                    <span className="checkmark"></span>
                </div>
                <p id="billingAgreementData" className="checkbox-label">{billingAgreementText}</p>
            </div>
            {<StripeButtons isValid={isValid} isDisabled={isDisabled} metadataMap={metadataMap} ctaText={checkoutMetadataMap?.subscribeCtaText} moduleData={moduleData} />}
            {offerCodeError && <div className="error notice-text">{offerCodeError} </div>}
            {offerCodeSuccess && <div className='success notice-text'>{offerCodeSuccess} </div>}
        </div>
    )
}

export default CcForm